module.exports = __webpack_public_path__ + "f472a7121e4272f3cf2d5e5f3341f942.jpg";